<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col>
                <h2 class="my-2">ユーザ一覧</h2>
            </v-col>
            <v-col class="text-right mt-3">
                <v-btn small color="success" @click="openDlgClick(0)"><h3>追加</h3></v-btn>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col cols="12" md="6" lg="4" v-for="obj of dbUsers" :key="obj.id">
                <v-card>
                    <v-toolbar color="indigo" dark>
                        <v-toolbar-title class="font-weight-bold">{{ obj.name }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <h4>管理番号：{{ obj.sort_no }}</h4>
                        <h4>Login ID：{{ obj.loginid }}</h4>
                        <h4>メール：{{ obj.email }}</h4>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn small color="success" @click="openDlgClick(obj.id)"><h3>編集</h3></v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showEditDlg" fullscreen transition="dialog-bottom-transition">
            <v-card color="grey lighten-4">
                <v-toolbar color="indigo" dark>
                    <v-toolbar-title>{{ dlgUser.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showEditDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text class="mt-10">
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="4">
                                            <v-text-field label="管理番号" v-model="dlgUser.sort_no" outlined dense type="number" hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="8">
                                            <v-text-field label="ユーザ名" v-model="dlgUser.name" outlined dense hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-text-field label="email" v-model="dlgUser.email" outlined dense hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="6">
                                            <v-text-field label="Login ID" v-model="dlgUser.loginid" outlined dense hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field label="Login PW" v-model="dlgUser.loginpw" outlined dense hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-select label="アクセス権限" v-model="dlgUser.role" :items="optRole" outlined dense hide-details></v-select>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-select label="ログイン許可" v-model="dlgUser.is_active" :items="optActive" outlined dense hide-details></v-select>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <!-- --------------------- -->
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col class="text-center pa-0" v-show="dlgUser.id > 0">
                            <v-btn color="error" @click="showDelDlg = true" width="100">削除</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="showEditDlg = false" width="100" outlined>キャンセル</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="axiosSubmit()" width="100">登録</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <!-- --------------------- -->
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showDelDlg" persistent>
            <v-card>
                <v-toolbar color="indigo" dark>確認</v-toolbar>
                <v-card-title>
                    <h5>「{{ dlgUser.name }}」を削除してもよろしいですか？</h5>
                </v-card-title>
                <v-card-actions>
                    <v-btn width="100" color="error" class="float-left" @click="axiosDelete()">削除！</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn width="100" color="success" outlined @click="showDelDlg = false">キャンセル</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
    </v-container>
</template>

<script>
export default {
    name: "Users",
    data() {
        return {
            jwt: "",
            myInfo: { id: 0, name: "", user_id: 0, site_id: 0 },
            showEditDlg: false,
            showDelDlg: false,
            isLoading: false,
            dbUsers: [],
            dlgUser: {
                id: 0,
                site_id: 0,
                name: "ユーザ名",
                sort_no: 999,
                loginid: "",
                loginpw: "",
                role: "user",
                email: "",
                is_active: 1,
            },
            optRole: [
                { text: "管理者レベル", value: "mgr" },
                { text: "ユーザレベル", value: "user" },
            ],
            optActive: [
                { text: "有効", value: 1 },
                { text: "無効", value: 0 },
            ],
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------------------------------
        this.isLoading = true;
        //-----------------------
        //非同期でAxiosGet
        const promiseFeeder = this.axiosGetFeeders();
        //-----------------------
        //上記の終了を待つ
        await promiseFeeder;
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        //-----------------------
        this.isLoading = false;
        window.scrollTo(0, 0);
        //-----------------------------------------------
    },
    //========================================================
    methods: {
        //===================================================
        async axiosGetFeeders() {
            await this.axios({
                method: "GET",
                url: "/web/api/users",
                params: { "_order[sort_no]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbUsers = response.data.json;
                this.optFeeders = [{ text: "-----", value: 0 }];
                for (let item of this.dbUsers) {
                    this.optFeeders.push({ text: item.name, value: item.id });
                }
            });
        },
        //===================================================
        // 変更ダイアログ表示
        //===================================================
        openDlgClick(primaryKey) {
            //-----------------------------
            if (primaryKey) {
                for (let obj of this.dbUsers) {
                    if (obj.id == primaryKey) {
                        this.dlgUser = JSON.parse(JSON.stringify(obj));
                    }
                }
            } else {
                this.dlgUser["id"] = 0;
                this.dlgUser["name"] = "";
                this.dlgUser["sort_no"] = 100;
                this.dlgUser["loginid"] = "";
                this.dlgUser["loginpw"] = "";
                this.dlgUser["role"] = "user";
                this.dlgUser["email"] = "";
                this.dlgUser["is_active"] = 1;
                delete this.dlgUser["modified"];
            }
            this.showEditDlg = true;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosSubmit() {
            let ErrCount = 0;
            if (!this.dlgUser["name"]) ErrCount++;
            if (!this.dlgUser["sort_no"]) ErrCount++;
            if (!this.dlgUser["name"]) ErrCount++;
            if (!this.dlgUser["loginid"]) ErrCount++;
            if (!this.dlgUser["loginpw"]) ErrCount++;
            if (ErrCount) {
                alert("未入力項目があります。");
                return false;
            }
            //-----------------------------------
            this.isLoading = true;
            this.showEditDlg = false;
            //-----------------------------------
            const axiosData = JSON.parse(JSON.stringify(this.dlgUser));
            axiosData["site_id"] = this.myInfo.site_id;
            axiosData["name"] = axiosData["name"].trim();
            axiosData["loginid"] = axiosData["loginid"].trim();
            axiosData["loginpw"] = axiosData["loginpw"].trim();
            delete axiosData["modified"];
            delete axiosData["operated_at"];
            //-----------------------------------
            const primaryKey = this.dlgUser.id;
            let restMethod = "PUT";
            if (primaryKey == 0) restMethod = "POST";

            let restUrl = "/web/api/users";
            if (primaryKey > 0) restUrl = restUrl + "/" + primaryKey;

            await this.axios({
                method: restMethod,
                url: restUrl,
                headers: { Authorization: "Bearer " + this.jwt },
                data: axiosData,
                timeout: 30000,
            })
                .then(() => {
                    this.axiosGetFeeders();
                })
                .catch(function (error) {
                    if (error.response.data.err == "ER_DUP_ENTRY") {
                        alert("重複しています。\n保存できません。");
                    } else {
                        alert("ん？ " + error.response.data.err);
                    }
                });
            //-----------------------------------
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
        //===================================================
        // 給餌プランDataをサブミット
        //===================================================
        async axiosDelete() {
            this.showDelDlg = false;
            this.showEditDlg = false;
            this.isLoading = true;
            //-------------------------
            const PrimaryKey = this.dlgUser.id;
            await this.axios({
                method: "DELETE",
                url: "/web/api/users/" + PrimaryKey,
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then(() => {
                this.axiosGetFeeders();
            });
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
        //===================================================
    },
    //========================================================
};
</script>
